export default "__VITE_PUBLIC_ASSET__11df2ed4__"